import ajaxFor from '@/utils/ajaxSet';

export function login(params){

     return ajaxFor({
          url:'/User/User/login',
          method:"post",
          data:params
     })

}

export function imgCodeFirm(params){

     return ajaxFor({
          url:'/User/User/requestSmsCode',
          method:"post",
          data:params
     })

}

export function phoneCode(params){

     return ajaxFor({
          url:'/User/User/requestSmsCode',
          method:"post",
          data:params
     })

}

export function passwordSet(params){

     return ajaxFor({
          url:'/User/User/resetPassword',
          method:"post",
          data:params
     })

}

export function reLogin(params){

     return ajaxFor({
          url:'/User/User/getUserByToken',
          method:"post",
          data:params
     })

}

export function wxLogin(params){

  return ajaxFor({
       url:'/User/User/wechatLogin',
       method:"post",
       data:params
  })

}

export function ipLogin(params){

  return ajaxFor({
       url:'/User/User/ipLogin',
       method:"post",
       data:params
  })

}

export function setOut(params){

  return ajaxFor({
       url:'/User/User/logout',
       method:"post",
       data:params
  })

}
